export default __webpack_public_path__ + "static/media/PSTN.b0257cd1.svg";